import { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
const AddDate = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => <svg ref={ref} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M17.25 3.13H4.75a.63.63 0 0 0-.63.62v12.5c0 .35.28.63.63.63h12.5c.35 0 .63-.28.63-.63V3.75a.63.63 0 0 0-.63-.62ZM14.75 1.88v2.5M7.25 1.88v2.5M4.13 6.88h13.75M13.19 11.88H8.8M11 9.69v4.37" />
  </svg>);
export default AddDate;